<template>
  <div class="flex">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="h-26px diy-table-button relative px-8px text-12px cursor-pointer"
      @click="btnClick(item)"
      :class="{
        active: value === item,
        'ml-10px': index !== 0,
        '!cursor-not-allowed': disabledList.includes(item),
      }"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      require: true,
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    disabledList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    btnClick(item) {
      if (this.disabledList.includes(item)) return
      this.$emit('input', item)
      this.$emit('btn-click', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-table-button {
  border: 1px solid var(--diyTableButtonBorderColor);
  background: var(--diyTableButtonBg);
  color: var(--diyTableButtonColor);
  line-height: 26px;
  text-align: center;
  &::before {
    content: '';
    height: 26px;
    width: 6px;
    background: var(--diyTableButtonCornerLeft) 0 0 no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -1px;
    left: -1px;
  }
  &::after {
    content: '';
    height: 26px;
    width: 6px;
    background: var(--diyTableButtonCornerRight) 0 0 no-repeat;
    position: absolute;
    top: -1px;
    right: -1px;
  }
  &.active {
    border-color: var(--diyTableButtonActiveBorderColor);
    background: var(--diyTableButtonActiveBg);
    color: var(--diyTableButtonActiveColor);
    &::before {
      background-image: var(--diyTableButtonActiveCornerLeft);
    }
    &::after {
      background-image: var(--diyTableButtonActiveCornerRight);
    }
  }
}
</style>
